import API from '@/shared/plugins/Api/API'
import { fetchAllPages } from './cursorPagination'

class TagsV3 extends API {
  constructor (id) {
    super(id)
    this.prefix = '/public/v1'
  }

  _appUrl (appName) {
    return `${this.prefix}/application/${encodeURIComponent(appName)}`
  }

  async listAll (params = {}) {
    const response = await this.request({
      method: 'get',
      url: `${this.prefix}/tag`,
      params
    })
    return response
  }

  // Cursor-paginated server-side (100 per page); callers still get every tag of
  // the application in one array. The global /tag list above keeps its own
  // offset pagination and is deliberately left alone.
  async list (appName) {
    return fetchAllPages(this, { url: `${this._appUrl(appName)}/tag` })
  }

  async get (appName, tagName) {
    const response = await this.request({
      method: 'get',
      url: `${this._appUrl(appName)}/tag/${encodeURIComponent(tagName)}`
    })
    return response
  }

  async create (appName, body, { autoBuild, autoDeploy } = {}) {
    const params = {}
    if (autoBuild) params.autoBuild = true
    if (autoDeploy) params.autoDeploy = true
    const response = await this.request({
      method: 'post',
      url: `${this._appUrl(appName)}/tag`,
      data: body,
      params
    })
    return response
  }

  async uploadCreate (appName, { tagName, description, file }, { autoBuild, autoDeploy } = {}) {
    const params = {}
    if (autoBuild) params.autoBuild = true
    if (autoDeploy) params.autoDeploy = true
    const formData = new FormData()
    formData.append('tagName', tagName)
    if (description) formData.append('description', description)
    formData.append('source', 'UPLOAD')
    formData.append('file', file)
    const response = await this.request({
      method: 'post',
      url: `${this._appUrl(appName)}/tag`,
      data: formData,
      params,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    return response
  }

  async update (appName, tagName, body) {
    const response = await this.request({
      method: 'put',
      url: `${this._appUrl(appName)}/tag/${encodeURIComponent(tagName)}`,
      data: body
    })
    return response
  }

  async delete (appName, tagName) {
    await this.request({
      method: 'delete',
      url: `${this._appUrl(appName)}/tag/${encodeURIComponent(tagName)}`
    })
  }

  async downloadArchive (appName, tagName) {
    return this.request({
      method: 'get',
      url: `${this._appUrl(appName)}/tag/${encodeURIComponent(tagName)}/archive`,
      responseType: 'blob'
    })
  }

  async reloadModules (appName, tagName) {
    await this.request({
      method: 'post',
      url: `${this._appUrl(appName)}/tag/${encodeURIComponent(tagName)}/module/reload`
    })
  }
}

export default TagsV3
